module.exports = __webpack_public_path__ + "img/partner7.e6b9cf12.png";